<template>
  <ValidationObserver
    id="loginform"
    class="form-horizontal form-material"
    ref="observer"
    autocomplete="off"
    tag="form"
    role="form"
    @submit.prevent="submit"
  >
    <div class="form-group">
      <ValidationProvider
        class="input-wrapper"
        v-slot="{ errors }"
        name="organizationId"
        rules="required"
      >
        <v-text-field
          v-model="form.organizationId"
          height="45px"
          ref="organizationId"
          label="Organization ID"
          name="organizationId"
          prepend-inner-icon="mdi-office-building"
        />
        <span class="error-message">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <ValidationProvider
        class="input-wrapper"
        v-slot="{ errors }"
        name="username"
        rules="required"
      >
        <v-text-field
          v-model="form.username"
          ref="username"
          name='username'
          height="45px"
          label="User Name"
          prepend-inner-icon="mdi-email"
        />
        <span class="error-message">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
       <ValidationProvider
        class="input-wrapper"
        v-slot="{ errors }"
        name="password"
        rules="required"
      >
        <v-text-field
          v-model="form.password"
          height="45px"
          ref="password"
          prepend-inner-icon="mdi-shield-lock"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          name="password"
          label="Password"
          hint="At least 8 characters"
          counter
          @click:append="show1 = !show1"
        />
        <span class="error-message">{{ errors[0] }}</span>
       </ValidationProvider>
    </div>

    <div class="form-group text-center m-t-20">
      <div class="container-login100-form-btn">
        <v-btn
          height="42px"
          width="100%"
          padding="0 10px"
          color="primary"
          type="submit"
          rounded
          :loading="loading"
          :disabled="loading"
        >
          <v-icon left dark>
            mdi-lock
          </v-icon>
          Login
        </v-btn>
        <div class="forgot-pwd">
          <a @click.prevent="changePassword">Forgot Password?</a>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>
<script>
import Promise from "../../../../lib/mixins/ExtendedPromises";
import Auth from "../../../../repositories/auth";
import { encode, decode } from "js-base64";

export default {
  name: "Login",
  mixins: [Promise],
  data() {
    return {
      isLoading: "",
      show1: false,
      dialog: true,
      username: "",
      password: "",
      social_login_providers: [],
      form: {
        organizationId: "",
        username: "",
        password: ""
      },
      isLoginWrong: false,
      loading: false
    };
  },

  computed: {
    authError() {
      return this.$store.getters.authError;
    }
  },

  mounted() {
    if (this.form.organizationId === "") {
      this.$refs.organizationId.focus();
    } else if (this.form.username === "") {
      this.$refs.username.focus();
    } else if (this.form.password === "") {
      this.$refs.password.focus();
    }
  },

  methods: {
    changePassword () {
      this.$router.push('/reset-password')
    },
    async submit() {
      
      const valid = await this.$refs.observer.validate();
      let invalidField = [];
      for (const [key, value] of Object.entries(this.$refs.observer.fields)) {
          if(!value.valid){
            invalidField.push(key)
          }
      }
      if(invalidField.length > 0) this.$refs[invalidField[0]].focus();
       
      if (valid) {
        this.loading = true;
        this.$store.dispatch("login");
        let loginDetail = { ...this.form };
        for (const [key, value] of Object.entries(loginDetail)) {
          loginDetail[key] = encode(value);
        }
        const operation = this.response(Auth.login(loginDetail));

        operation
          .then(data => {
            if (operation.isFulfilled()) {
              this.$store.commit("loginSuccess", data);
              if(data.changePassword){
                this.$router.push("/reset");
              } else {
                this.$router.push("/dashboard");
              }
              
              this.loading = false;
            }
          })
          .catch(err => {
             this.loading = false;
              this.$toasted.show(
                  err.data.message,{
                    type:'error'
                  }
                );
            if (operation.isRejected()) {
              if (err.status === 403) {
                this.isLoginWrong = true;
                this.$toasted.show(
                  "These credentials do not match our records.",{
                    type:'error'
                  }
                );
              }
              this.$store.commit("loginFailed", { err });
            }
           
          });
      }
    },

    getConfig(config) {}
  }
};
</script>
